import React from "react"
import moment from "moment";
import ApiService from "../../../services/ApiService";
import Link from "next/link";
import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import logger from "../../../services/logger"

export default class PreviewArticle extends React.Component{

  state = {
    data: [],
  };

  componentDidMount() {
    this.getData()
  }

  async getData()
  {
    const context = this.props.context

    var res = await ApiService.get("/auto-content/preview?lang="+context.langValue)
    logger.debug({ res }, "res")

    if (Array.isArray(res.data)) {
      this.setState({
        data: res.data,
      });
    }
  };

  render()
  {
    const context = this.props.context
    const {org} = context
    const data = this.state.data

    if (org.limited) {
      return null
    }

    if (!Array.isArray(data) || data.length === 0) {
      return null
    }

    const hasContentHub = (org.pages || []).some(p => p.type === "CONTENT_HUB")
    const allArticlesHref = `${org.BASE_WEB_URL}/jewish-educations`

    return (
        <div className="blog-area section-padding">
          <div className="container">
            <div className="col-l2">
              <div className="wpo-section-title">
                <span>{t`Nos Articles`}</span>
                <h2>{t`Étude et Inspirations`}</h2>
              </div>
            </div>

            <div className="row" style={{rowGap:20}}>
              {data.map(item => {

                let target = null
                let link = `${org.BASE_WEB_URL}/article/${item._id}`

                if(item.source !== "LOUBAVITCH"){
                  target = "_blank"
                  link = item.source_link
                }

                return(
                    <div
                        className="col-lg-4 col-md-6 col-12 custom-grid"
                        key={item.key}
                        style={{ display: "flex" }}   // permet cartes égales
                    >
                      <div
                          className="blog-item"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            height: "100%"
                          }}
                      >

                        {/* IMAGE */}
                        <div
                            className="blog-img"
                            style={{
                              height: "260px",
                              overflow: "hidden"
                            }}
                        >
                          <img
                              src={item.image}
                              alt=""
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block"
                              }}
                          />
                        </div>

                        {/* CONTENT */}
                        <div
                            className="blog-content"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flex: 1,
                              padding: "20px"
                            }}
                        >
                          <h3>
                            <Link href={link} target={target}>
                              {item.title}
                            </Link>
                          </h3>

                          <p
                              style={{
                                display: "-webkit-box",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                              }}
                          >
                            {item.description}
                          </p>

                          {/* META EN BAS */}
                          <ul
                              className="post-meta"
                              style={{
                                marginTop: "auto",
                                paddingTop: "15px",
                                borderTop: "1px solid #eee"
                              }}
                          >
                            <li>
                              <a target="_blank" href={item.credits[0].link}>
                                {item.credits[0].name}
                              </a>
                            </li>

                            {item.datetime &&(
                                <li>
                                  <i className="fa fa-clock-o" aria-hidden="true"></i>{" "}
                                  {moment(item.datetime).format("DD MMM YYYY")}
                                </li>
                            )}
                          </ul>

                        </div>
                      </div>
                    </div>
                )
              })}
            </div>

            {hasContentHub && (
                <div style={{textAlign:"center", marginTop:30}}>
                  <Link
                      href={allArticlesHref}
                      className="theme-btn"
                      style={{display:"inline-block"}}
                  >
                    <Trans>Voir plus d'articles</Trans>
                  </Link>
                </div>
            )}
          </div>
        </div>
    )

  }
}
